const prefix = 'fasr';
const iconName = 'text-height';
const width = 576;
const height = 512;
const aliases = [];
const unicode = 'f034';
const svgPathData = 'M24 32H0V56v72 24H48V128 80h88l0 352H88 64v48H88 232h24V432H232 184l0-352h88v48 24h48V128 56 32H296 24zM497 50.2l-17-17-17 17L402.2 111l-17 17 33.9 33.9 17-17L456 125.1V386.9L436.2 367l-17-17L385.3 384l17 17L463 461.8l17 17 17-17L557.8 401l17-17-33.9-33.9-17 17L504 386.9V125.1L523.8 145l17 17L574.7 128l-17-17L497 50.2z';

export default {
  prefix,
  iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ] };
